<template>
  <sameday-item-card
    :loading="false"
    :params="params"
    role="alert"
    aria-live="assertive"
  >
    <sameday-error
      class="h-10 mt-4"
      role="status"
    >
      <span
        class="flex space-x-1"
        id="error-message"
      >
        <span
          class="text-sm"
          aria-live="polite"
        >Something went wrong.</span>
        <button
          type="button"
          class="text-sm font-bold"
          @click="$emit('on:retry')"
          aria-label="Retry loading content"
          aria-describedby="error-message"
        >
          Retry
        </button>
      </span>
    </sameday-error>
  </sameday-item-card>
</template>

<script>
import SamedayItemCard from "@/components/Sameday/SamedayItemCard.vue";
import SamedayError from "@/components/Alert/AlertWarning.vue";

export default {
  components: {
    SamedayItemCard,
    SamedayError,
  },
  props: {
    params: {
      type: Object,
      default: () => {},
    },
  },
};
</script>